import { closeModalAnalytics } from "@/utils/helper"

export const addFirstReviewAnalyticsEvent = productInfo => {
  setTimeout(() => {
    const actualFirstReviewButton = document.getElementById("first-to-write")
    if (
      !window.isFirstReviewEventLoaded &&
      actualFirstReviewButton &&
      productInfo
    ) {
      // this means review contents are loaded
      actualFirstReviewButton.addEventListener("click", () =>
        clickEvent("be the first to review this product", productInfo)
      )
      window.isFirstReviewEventLoaded = true
    } else if (
      !window.isFirstReviewEventLoaded &&
      (!window.reiterate || window.reiterate < 10)
    ) {
      window.reiterate = (window.reiterate ?? 0) + 1
      addFirstReviewAnalyticsEvent(productInfo)
    }
  }, 2000)
}

export const addWriteReviewAnalyticsEvent = productInfo => {
  setTimeout(() => {
    const actualWriteReviewButtons =
      document.getElementsByClassName("bv-write-review")
    if (
      !window.isWriteReviewEventLoaded &&
      actualWriteReviewButtons?.length &&
      productInfo
    ) {
      const actualWriteReviewButton = actualWriteReviewButtons[0]
      // this means review contents are loaded
      actualWriteReviewButton.addEventListener("click", () =>
        clickEvent("write a review", productInfo)
      )
      window.isWriteReviewEventLoaded = true
    } else if (
      !window.isWriteReviewEventLoaded &&
      (!window.reiterate1 || window.reiterate1 < 10)
    ) {
      window.reiterate1 = (window.reiterate1 ?? 0) + 1
      addWriteReviewAnalyticsEvent(productInfo)
    }
  }, 2000)
}

const clickEvent = (type, productInfo) => {
  const eventInfo = getEventInfo(type)
  const productInfoA = productInfo ? JSON.parse(productInfo).productInfo : null
  const { adobeDataLayer: { getState } = {} } = window
  const page = (getState && getState("page")) || {}
  window.adobeDataLayer.push({
    event: "cmp:click",
    eventInfo,
    page,
    productInfo: productInfoA,
  })
  closeModalAnalytics(productInfo)
}

const getEventInfo = type => {
  return {
    eventAction: "pdp:customer reviews:" + type,
    eventName: "pdp:customer reviews:" + type,
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: type,
    internalLinkPosition: "pdp",
    internalLinkType: "pdp:navigation",
    internalLinkZoneName: "pdp:customer reviews",
    internalLinkURL: "n/a",
    clickInternalLinks: "true",
  }
}
